"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsafeEditExtraDataCommand = void 0;
const cq_core_1 = require("@leavy/cq-core");
const validator_1 = require("@leavy/validator");
const CommonOnboardingDataTypeId_1 = require("../domain/CommonOnboardingDataTypeId");
const HlOnboardingDataTypeId_1 = require("../../hl/domain/HlOnboardingDataTypeId");
const HodOnboardingDataTypeId_1 = require("../../hod/domain/HodOnboardingDataTypeId");
const base_1 = require("../../base");
const BaseOnboardingCommand_1 = require("./BaseOnboardingCommand");
let UnsafeEditExtraDataCommand = class UnsafeEditExtraDataCommand extends BaseOnboardingCommand_1.BaseOnboardingCommand {
};
__decorate([
    (0, validator_1.IsIn)([
        ...Object.values(CommonOnboardingDataTypeId_1.CommonOnboardingDataTypeId),
        ...Object.values(HlOnboardingDataTypeId_1.HlOnboardingDataTypeId),
        ...Object.values(HodOnboardingDataTypeId_1.HodOnboardingDataTypeId),
    ]),
    __metadata("design:type", Object)
], UnsafeEditExtraDataCommand.prototype, "dataTypeId", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsObject)(),
    __metadata("design:type", Object)
], UnsafeEditExtraDataCommand.prototype, "value", void 0);
UnsafeEditExtraDataCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "unsafe_edit_extra_data",
    })
], UnsafeEditExtraDataCommand);
exports.UnsafeEditExtraDataCommand = UnsafeEditExtraDataCommand;
//# sourceMappingURL=UnsafeEditExtraDataCommand.js.map